import { defineMessages } from "react-intl";

export const reportStaysFilterMessages = defineMessages({
  startDate: {
    id: "report.stays.startDate",
    defaultMessage: "Start date"
  },
  endDate: {
    id: "report.stays.endDate",
    defaultMessage: "End date"
  },
  hotelTickers: {
    id: "report.stays.hotel",
    defaultMessage: "Hotel"
  },
  tickets: {
    id: "report.stays.tickets",
    defaultMessage: "Tickets"
  },
  stays: {
    id: "report.stays.stays",
    defaultMessage: "Stays"
  },
  departures: {
    id: "report.stays.departures",
    defaultMessage: "Departures"
  },
  showComments: {
    id: "report.stays.showComments",
    defaultMessage: "Show comments"
  },
  order: {
    id: "report.stays.order",
    defaultMessage: "Order {index}"
  },
  orderOne: {
    id: "report.stays.orderOne",
    defaultMessage: "Order 1"
  },
  orderTwo: {
    id: "report.stays.orderTwo",
    defaultMessage: "Order 2"
  },
  orderThree: {
    id: "report.stays.orderThree",
    defaultMessage: "Order 3"
  },
  filter: {
    id: "report.stays.filter",
    defaultMessage: "Filter"
  },
  asc: {
    id: "report.stays.asc",
    defaultMessage: "Asc"
  },
  desc: {
    id: "report.stays.desc",
    defaultMessage: "Desc"
  },
  date: {
    id: "report.stays.date",
    defaultMessage: "Date"
  },
  dayOfTheWeek: {
    id: "report.stays.dayOfTheWeek",
    defaultMessage: "NameDay"
  },
  action: {
    id: "report.stays.action",
    defaultMessage: "Action"
  },
  currentNight: {
    id: "report.stays.currentNight",
    defaultMessage: "Night"
  },
  totalNights: {
    id: "report.stays.totalNights",
    defaultMessage: "Nights"
  },
  bookingId: {
    id: "report.stays.bookingId",
    defaultMessage: "Locations"
  },
  multipleBookingId: {
    id: "report.stays.multipleBookingId",
    defaultMessage: "Locator multiple"
  },
  customerName: {
    id: "report.stays.customerName",
    defaultMessage: "Name"
  },
  rooms: {
    id: "report.stays.rooms",
    defaultMessage: "Units"
  },
  inventoryTicker: {
    id: "report.stays.roomTicker",
    defaultMessage: "Ticker"
  },
  capacity: {
    id: "report.stays.capacity",
    defaultMessage: "Pers"
  },
  extras: {
    id: "report.stays.extras",
    defaultMessage: "Extras"
  },
  comments: {
    id: "report.stays.comments",
    defaultMessage: "Comments"
  },
});

export const reportStaysMessages = defineMessages({
  title: {
    id: "report.stays.title",
    defaultMessage: "Stays per day"
  },
  period: {
    id: "report.stays.period",
    defaultMessage: "Period"
  },
  date: {
    id: "report.stays.date",
    defaultMessage: "Date"
  },
  dayOfTheWeek: {
    id: "report.stays.dayOfTheWeek",
    defaultMessage: "NameDay"
  },
  action: {
    id: "report.stays.action",
    defaultMessage: "Action"
  },
  currentNight: {
    id: "report.stays.currentNight",
    defaultMessage: "Night"
  },
  totalNights: {
    id: "report.stays.totalNights",
    defaultMessage: "Nights"
  },
  bookingId: {
    id: "report.stays.bookingId",
    defaultMessage: "Locations"
  },
  multipleBookingId: {
    id: "report.stays.multipleBookingId",
    defaultMessage: "Locator multiple"
  },
  customerName: {
    id: "report.stays.customerName",
    defaultMessage: "Name"
  },
  rooms: {
    id: "report.stays.rooms",
    defaultMessage: "Units"
  },
  inventoryTicker: {
    id: "report.stays.roomTicker",
    defaultMessage: "Ticker"
  },
  capacity: {
    id: "report.stays.capacity",
    defaultMessage: "Pers"
  },
  extras: {
    id: "report.stays.extras",
    defaultMessage: "Extras"
  },
  comments: {
    id: "report.stays.comments",
    defaultMessage: "Comments"
  },
  totalSum: {
    id: "report.stays.totalSum",
    defaultMessage: "Total sum"
  },
  average: {
    id: "report.stays.average",
    defaultMessage: "Average"
  },
  consult: {
    id: "report.stays.consult",
    defaultMessage: "Consult"
  },
  exportToExcel: {
    id: "report.stays.exportToExcel",
    defaultMessage: "Export to Excel"
  },
  resultsPerPage: {
    id: "report.stays.resultsPerPage",
    defaultMessage: "Results per page"
  },
  tableNoItems: {
    id: "report.stays.tableNoItems",
    defaultMessage: "Results are not found",
  },
  hotelTickers: {
    id: "report.stays.hotel",
    defaultMessage: "Hotel"
  },
  tickets: {
    id: "report.stays.tickets",
    defaultMessage: "Tickets"
  },
  stays: {
    id: "report.stays.stays",
    defaultMessage: "Stays"
  },
  departures: {
    id: "report.stays.departures",
    defaultMessage: "Departures"
  },
  showComments: {
    id: "report.stays.showComments",
    defaultMessage: "Show comments"
  },
  order: {
    id: "report.stays.order",
    defaultMessage: "Order {index}"
  },
  orderOne: {
    id: "report.stays.orderOne",
    defaultMessage: "Order 1"
  },
  orderTwo: {
    id: "report.stays.orderTwo",
    defaultMessage: "Order 2"
  },
  orderThree: {
    id: "report.stays.orderThree",
    defaultMessage: "Order 3"
  },
  monday: {
    id: "report.stays.monday",
    defaultMessage: "Mo"
  },
  tuesday: {
    id: "report.stays.tuesday",
    defaultMessage: "Tu"
  },
  wednesday: {
    id: "report.stays.wednesday",
    defaultMessage: "We"
  },
  thursday: {
    id: "report.stays.thursday",
    defaultMessage: "Th"
  },
  friday: {
    id: "report.stays.friday",
    defaultMessage: "Fr"
  },
  saturday: {
    id: "report.stays.saturday",
    defaultMessage: "Sa"
  },
  sunday: {
    id: "report.stays.sunday",
    defaultMessage: "Su"
  },
  detail: {
    id: "report.stays.tooltipDetail",
    defaultMessage: "Booking details",
  },
  checkIn: {
    id: "report.stays.checkIn",
    defaultMessage: "Check-in",
  },
  checkOut: {
    id: "report.stays.checkOut",
    defaultMessage: "Check-out",
  },
  stay: {
    id: "report.stays.stay",
    defaultMessage: "Stay",
  },
});
